import * as SentryReact from '@sentry/react'
import type { IUser } from '@/shared/api/users'

export const Sentry = window.sentryConfig ? SentryReact : null

export function initSentryPerhaps() {
  if (window.sentryConfig) {
    Sentry?.init({
      dsn: window.sentryConfig.dsn,
      release: window.sentryConfig.release,
      environment: window.sentryConfig.environment,
      tracesSampleRate: window.sentryConfig.tracesSampleRate,
      beforeSend(event, hint) {
        const error = hint.originalException
        if (error instanceof Error) {
          const extras: Record<string, unknown> = {}
          for (const key of Object.keys(error)) {
            if (key !== 'name' && key !== 'message' && key !== 'stack') {
              extras[key] = (error as unknown as Record<string, unknown>)[key]
            }
          }
          if (Object.keys(extras).length > 0) {
            event.extra = { ...event.extra, ...extras }
          }
        }
        return event
      },
    })
  }
}

export function setSentryUserPerhaps(user: Nullable<IUser>) {
  // TODO: Conditionally set if impersonating user?
  if (user) {
    Sentry?.setUser({
      id: user.id,
      email: user.email,
    })
  }
}
